<template>
  <div></div>
</template>

<script>
import { ref, onMounted, watch } from 'vue'
import { useRoute } from 'vue-router'

export default {
  name: 'CivsPopupViews',
  setup() {
    const route = useRoute()
    const handleRouteChange = async () => {
      const jsonResponse = ref('')
      if (route.path === '/civs_result') {
        const getParameterByName = (name) => {
          const params = new URLSearchParams(route.query)
          return params.get(name) || ''
        }

        const txSn = getParameterByName('txSn')
        const retCd = getParameterByName('retCd')
        const resData = getParameterByName('resData')
        const sid = localStorage.getItem('sid')

        console.log('~~Logging values for data~~')
        console.log('txSn ::: ', txSn)
        console.log('retCd ::: ', retCd)
        console.log('resData ::: ', resData)
        console.log('sid ::: ', sid)

        const data = {
          tx_sn: txSn,
          ret_cd: retCd,
          res_data: resData,
          // eslint-disable-next-line object-shorthand
          sid: sid,
        }
        console.log(txSn)
        try {
          const url = `${process.env.VUE_APP_LMS_URL}/api/v1/member/auth/civs/callback`
          await fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json;charset=utf-8' },
            body: JSON.stringify(data),
          })
        } catch (error) {
          console.error('Error during CIVS callback:', error)
          window.close()
        }
      }
      window.close()
    }
    window.addEventListener('beforeunload', () => {
      window.opener.postMessage('popupClosed', '*')
    })
    onMounted(() => {
      // console.log('onMounted executed')
      handleRouteChange()
    })

    // Watch for changes in the route query or path
    watch(
      () => route.query,
      () => {
        handleRouteChange()
      }
    )

    watch(
      () => route.path,
      () => {
        handleRouteChange()
      }
    )
    return {}
  },
}
</script>
